import { Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getAuthToken, removeAuthToken } from "../utils/token";

type Props = {};

const PublicRoute = ({ roles, children }: any) => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(true);

  useEffect(() => {
    async function validateIfLoggedIn() {
      const token = await getAuthToken();

      if (token) {
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
        await removeAuthToken();
      }
      setLoading(false);
    }
    validateIfLoggedIn();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  if (loggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return children ? children : <Outlet />;
};

export default PublicRoute;
